import { mapGetters } from 'vuex'

export const isDepositEnabled = {
  computed: {
    ...mapGetters('settings', ['isDepositEnabled'])
  }
}
